import actionTypes from "../../actions/actionTypes";
import updateObject from '../../../utils/updateObject';

const initialState = {
  data: [],
  fetching: true,
  error: null,
};

const fetchAvailable = (state, action) => {
  return updateObject(state, {
    fetching: true,
    data: [],
    error: null
  });
}

const fetchAvailableOk = (state, action) => {
  return updateObject(state, {
    fetching: false,
    data: action.data.Plans,
    error: null
  });
}

const fetchAvailableError = (state, action) => {
  return updateObject(state, {
    fetching: false,
    data: [],
    error: action.error
  });
}

export default function reducer(state = initialState, action) {
  switch(action.type) {
    case actionTypes.plan.FETCH_AVAILABLE:
      return fetchAvailable(state, action);
    case actionTypes.plan.FETCH_AVAILABLE_OK:
      return fetchAvailableOk(state, action);
    case actionTypes.plan.FETCH_AVAILABLE_ERROR:
      return fetchAvailableError(state, action);
    default:
      return state;
  }
}